/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speaker_Manager_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove Speaker" |
*
* @param {Speaker_Manager_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speaker_manager_remove_title = /** @type {((inputs?: Speaker_Manager_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speaker_Manager_Remove_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le locuteur")
	if (locale === "de") return /** @type {LocalizedString} */ ("Lautsprecher entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi altoparlante")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить динамик")
	if (locale === "es") return /** @type {LocalizedString} */ ("Quitar el altavoz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("移除扬声器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("スピーカーを削除")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्पीकर हटाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover alto-falante")
	return /** @type {LocalizedString} */ ("Remove Speaker")
});